document.addEventListener("DOMContentLoaded", function () {
  const collapsibleSections = document.querySelectorAll(".collapsed-webit");

  collapsibleSections.forEach(section => {
    const toggle = section.querySelector(".collapsed-toggle");

    if (!toggle) return;

    // S'assurer que la classe collapsed est bien appliquée
    section.classList.add("collapsed-webit");

    toggle.addEventListener("click", () => {
      section.classList.toggle("collapsed-webit");
      section.classList.toggle("expanded-webit");
    });
  });
});